import {Component, ElementRef, inject, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  BaseComponent,
  WmsDialogBodyComponent,
  WmsDialogFooterComponent,
  WmsDialogHeaderComponent, WmsMessageComponent
} from "@wms/components";
import {WMSFileUploadComponent} from "@wms/app/workspace/file-workspace/wms-file-upload/wms-file-upload.component";
import {forEach, get, startsWith} from "lodash-es";
import {isFileUploadSupported} from "@wavemaker/variables";
import {
  DialogService,
  FileService,
  NotificationService,
  PageTemplatesService,
  PrefabService,
  ProjectService,
  ThemeService, TreeService
} from "@wms/services";
import {getProjectResourcePath, isExeFile, isImageFile, isZipFile} from "@wms/core";
import {isEmptyObject, replace, runtimeEventManager, triggerFn} from "@wm/core";
import {Subscription} from "rxjs";
import { PrefabManager } from '../workspace/page-workspace/prefabs/prefab-manager';


const activeResource:any = {} ;
@Component({
  selector: 'wms-upload-resources-dialog',
  standalone: true,
  imports: [CommonModule, WmsDialogHeaderComponent, WmsDialogBodyComponent, WMSFileUploadComponent, WmsDialogFooterComponent, WmsMessageComponent],
  templateUrl: './upload-resources-dialog.component.html',
  styleUrls: ['./upload-resources-dialog.component.less']
})
export class UploadResourcesDialogComponent extends BaseComponent implements OnInit{
  uploadMessage:any;
  dialogTitleKey:any;
  folder:any;
  uploadMode:any
  showDropView:any;
  dndFilesList:any;
  fileName:any;
  messageClass:any;
  messageIconClass:any
  disableDialogActions:any
  mimeType:string = '';
  fileDetails:any;
  selectedUpload:any;
  resourceExists:boolean;
  warningShown:boolean;
  disableInactiveResources:any;
  fileUploadFallbackConfig={
    url:'',
    data:'',
    formName:''
  };
  selectedFiles: any;
  activePath: any;
  activeResource: any;
  projectId: any;
  prefabService: PrefabService
  themeService: ThemeService
  pageTemplatesService: PageTemplatesService
  fileService: FileService
  elRef: ElementRef
  resourceProperties: any;
  private rootEl: JQuery<HTMLElement>;
  selectedFolder: any
  selectedResource: any
  resourceView: any;
  resources: any;
  dialogeServce: DialogService
  updateTree: TreeService;
  resourcesTree: any;
  libTree: any;
  audioTree: any;
  serviceResourcesTree: any;
  imageTree: any
  videoTree: any
  projectResourcesTree: any;
  connectorTree: any;
  override projectService: ProjectService;
  public override registerDestroyListener = new Subscription();

   uploadTypes:any = {
    "jars": {"path": "../lib/",
      "dialogTileKey": "LABEL_IMPORT_JAR",
      "dialogIcon": "import-jar",
      "emitEvent": "update-lib-tree",
      "successMsg": "MESSAGE_SUCCESS_JAR_IMPORT_DESC",
      "errorMsg": "MESSAGE_ERROR_JAR_IMPORT_DESC"
    },
    "images": {"path": "resources/images/imagelists",
      "dialogTileKey": "LABEL_IMPORT_IMAGE",
      "dialogIcon": "import-image",
      "emitEvent": "update-image-tree",
      "successMsg": "MESSAGE_SUCCESS_IMAGE_IMPORT_DESC",
      "errorMsg": "MESSAGE_ERROR_IMAGE_IMPORT_DESC"
    },
    "audios": {"path": "resources/audios",
      "dialogTileKey": "LABEL_IMPORT_AUDIO",
      "dialogIcon": "audio",
      "emitEvent": "update-resources-tree",
      "successMsg": "MESSAGE_SUCCESS_AUDIO_IMPORT_DESC",
      "errorMsg": "MESSAGE_ERROR_AUDIO_IMPORT_DESC"
    },
    "connectors": {"path": "WEB-INF/connectors",
      "dialogTileKey": "LABEL_IMPORT_CONNECTOR",
      "dialogIcon": "import-file",
      "emitEvent": "update-connector-tree",
      "successMsg": "MESSAGE_SUCCESS_CONNECTOR_IMPORT_DESC",
      "errorMsg": "MESSAGE_ERROR_CONNECTOR_IMPORT_DESC"
    },
    "videos": {"path": "resources/videos",
      "dialogTileKey": "LABEL_IMPORT_VIDEO",
      "dialogIcon": "video",
      "emitEvent": "update-resources-tree",
      "successMsg": "MESSAGE_SUCCESS_VIDEO_IMPORT_DESC",
      "errorMsg": "MESSAGE_ERROR_VIDEO_IMPORT_DESC"
    },
    "files": {"path": "resources/files",
      "dialogTileKey": "LABEL_IMPORT_FILE",
      "dialogIcon": "import-file",
      "emitEvent": "update-resources-tree",
      "successMsg": "MESSAGE_SUCCESS_RESOURCE_IMPORT_DESC",
      "errorMsg": "MESSAGE_ERROR_RESOURCE_IMPORT_DESC"
    },
    "prefabs": {"path": "services/import",
      "dialogTileKey": "LABEL_IMPORT_PREFAB",
      "dialogIcon": "import-prefab",
      "data": [
        {"packageType": "PREFAB"}
      ],
      "emitEvent": "list-prefabs",
      "successMsg": "MESSAGE_SUCCESS_PREFAB_IMPORT_DESC",
      "errorMsg": "MESSAGE_ERROR_PREFAB_IMPORT_DESC"
    },
    "templatebundles": {"path": "services/import",
      "dialogTileKey": "LABEL_IMPORT_TEMPLATEBUNDLE",
      "dialogIcon": "import-template-bundle",
      "data": [
        {"packageType": "TEMPLATEBUNDLE"}
      ],
      "emitEvent": "list-templatebundles",
      "successMsg": "MESSAGE_SUCCESS_TEMPLATEBUNDLE_IMPORT_DESC",
      "errorMsg": "MESSAGE_ERROR_TEMPLATEBUNDLE_IMPORT_DESC"
    },
    "themes": {"path": "services/themes/import",
      "dialogTileKey": "LABEL_IMPORT_THEME",
      "dialogIcon": "import-theme",
      "data": [
        {"packageType": "THEME"}
      ],
      "emitEvent": "list-themes",
      "successMsg": "MESSAGE_SUCCESS_THEME_IMPORT_DESC",
      "errorMsg": "MESSAGE_ERROR_THEME_IMPORT_DESC"
    }
  };
  resourcesConfig = [
    {"name": "jar", "displayKey": "LABEL_FILES_TREE_LIB", "icon": "lib", "root": "../lib"},
    {"name": "services", "displayKey": "LABEL_FILES_TREE_SERVICES", "icon": "service", "root": "../services"},
    {"name": "image", "displayKey": "LABEL_IMAGE", "icon": "image", "root": "resources/images/imagelists"},
    {"name": "audio", "displayKey": "LABEL_AUDIO", "icon": "audio", "root": "resources/audios"},
    {"name": "video", "displayKey": "LABEL_VIDEO", "icon": "video", "root": "resources/videos"},
    {"name": "resources", "displayKey": "LABEL_FILES_TREE_RESOURCES", "icon": "resource", "root": "/resources"},
    {"name": "project", "displayKey": "LABEL_PROJECT", "icon": "project", "root": "../project"},
    {"name": "connector", "displayKey": "LABEL_CONNECTOR", "icon": "file", "root": "WEB-INF/connectors"}
  ];
   constructor(private notificationService: NotificationService,private prefabManager:PrefabManager) {
     super();
     this.prefabService = inject(PrefabService)
     this.fileService = inject(FileService)
     this.pageTemplatesService = inject(PageTemplatesService)
     this.themeService = inject(ThemeService)
     this.projectService = inject(ProjectService)
     this.dialogeServce = inject(DialogService);
     this.updateTree = inject(TreeService);
     this.elRef = inject(ElementRef);
     this.rootEl = $(this.elRef.nativeElement)
   }


  ngOnInit() {
    // uploadMode can be theme, templatebundle, prefab, resource or image.
    // it should be sent as dialogParam while opening the dialog.
    let dialogObject: any = this.dialogeServce.dialogs.find(dialog => dialog.id === 'uploadResourcesDialog');
    this.uploadMode = dialogObject.dialogParams;
    this.projectId = this.projectService.getProjectId();
    this.selectedUpload = this.uploadTypes[this.uploadMode];
    this.dialogTitleKey = this.uploadTypes[this.uploadMode].dialogTileKey
    this.resourceExists = false;
    this.warningShown = false;
    this.initDialog()
    // this.resourceProperties=  this.elRef.nativeElement(this.selectedFolder) ? this.selectedResource : this.selectedFolder;
  }

  initDialog() {
    let initResourceIndex = 0,
      resources: any;
    /*Restricting file types to import based on uploadMode, i.e Import image option should show
     only image types, import jars should show only .jar files and import prefabs should show only .zip files*/
    switch (this.uploadMode) {
      case "images":
        this.mimeType = 'image/*';
        initResourceIndex = 2;
        break;
      case "audios":
        this.mimeType = 'audio/*';
        initResourceIndex = 3;
        break;
      case "videos":
        initResourceIndex = 4;
        this.mimeType = 'video/*';
        break;
      case "files":
        initResourceIndex = 5;
        this.mimeType = '';
        break;
      case "jars":
        initResourceIndex = 0;
        this.mimeType = '.jar';
        break;
      case "resources":
        initResourceIndex = 5;
        this.mimeType = '';
        break;
      case "project":
        initResourceIndex = 6;
        this.mimeType = '';
        break;
      case "connectors":
        initResourceIndex = 7;
        this.mimeType = '';
        break;
      default:
        this.mimeType = '.zip';
        break;
    }

    if (this.uploadMode !== 'resources' && this.uploadMode !== 'project') {
      this.disableInactiveResources = true;
    }

    resources = this.resourcesConfig[initResourceIndex];

    // set the lastSelectedFolder when the images binding resource dialog is opened.
    if (this.resourceProperties?.renderFolderPath) {
      let $element: JQuery<HTMLElement> | any = get(this.rootEl, '.resource-list-container')
      let $treeEl = $element.find('.wm-tree'),
        node = $treeEl.find('.active-tree-element'),
        parentId,
        parentNode,
        _details;

      if (node?.length) {
        _details = node.data('details').props;

        if (_details.datatype === 'folder') {
          resources.lastSelectedFolder = _details.path;
        } else {
          parentId = node.attr('parent'),
            parentNode = $treeEl.find('[data-identifier =' + parentId + ']'),
            _details = parentNode.data('details').props;
          resources.lastSelectedFolder = _details.path;
        }
      }
    }

    /* initialize the tree with resources tree */
    this.changeActiveResource(resources);
  }


  changeActiveResource(resource: any) {
    let filePath;

    this.resourceView = resource.name;
    forEach(this.resources, (resource) => {
      resource.isActive = false;
    });
    resource.isActive = true;

    this.activeResource = resource;

    /**
     * Set the $scope.folder to lastSelectedFolder if available.
     * On select of other resource tab (i.e. image, jar, services)
     *  then set it to root path on resource obj only when lastSelectedFolder is not available.
     * If resource path in activeWS is available then set the folder to this path.
     * Otherwise set to the lastSelectedFolder path or selectedUpload path.
     */
    if (this.activeResource.lastSelectedFolder) {
      this.folder = this.activeResource.lastSelectedFolder;
    } else if (this.activeResource.name !== 'project') {
      this.folder = resource.root;
    }
      //   else if (this.activeResource.name === 'project' && this.activeWS && get($rootScope.activeWS, 'details.path')) {
      //   /**
      //    * If filePath is src/main/webapp/app.js (filePath) then set the activePath as filePath
      //    * If filePath is src/main/webapp (folderPath) then set the activePath as folderPath
      //    */
      //   if (this.activeWS.details.type === 'file') {
      //     filePath = this.activeWS.details.path;
      //     this.folder = this.getFolderPath(filePath);
      //   } else {
      //     this.folder = this.activeWS.details.path;
      //   }
    // }
    else {

      this.folder = activeResource.lastSelectedFolder || this.selectedUpload.path || '';
    }

    this.setActiveResource(filePath);
    this.updateResourceTree(resource.name, true);
  };

  /* updates the provided resource tree*/
  updateResourceTree(resource: any, forceReload: any) {
    switch (resource) {
      case "resources":
        if (!this.resourcesTree || forceReload) {
          this.resourcesTree = undefined;
          setTimeout(() => {
            if (this.updateTree) {
              this.updateTree.updateResourcesTree();
            } else {
              // $rootScope.$emit("update-resources-tree");
            }
          }, 0, false);
        }
        break;
      case "jar":
        if (!this.libTree || forceReload) {
          this.libTree = undefined;
          setTimeout(() => {
            if (this.updateTree) {
              this.updateTree.updateLibTree(false);
            } else {
              // $rootScope.$emit("update-lib-tree");
            }
          });
        }
        break;
      case "services":
        if (!this.serviceResourcesTree || forceReload) {
          this.serviceResourcesTree = undefined;
          setTimeout(() => {
            if (this.updateTree) {
              this.updateTree.updateServiceResourcesTree();
            } else {
              // $rootScope.$emit("update-service-resources-tree");
            }
          });
        }
        break;
      case "image":
        if (!this.imageTree || forceReload) {
          this.imageTree = undefined;
          setTimeout(() => {
            if (this.updateTree) {
              this.updateTree.updateImageTree();
            } else {
              // $rootScope.$emit("update-image-tree");
            }
          });
        }
        break;
      case "audio":
        if (!this.audioTree || forceReload) {
          this.audioTree = undefined;
          setTimeout(() => {
            if (this.updateTree) {
              this.updateTree.updateAudioTree();
            } else {
              // $rootScope.$emit("update-audio-tree");
            }
          });
        }
        break;
      case "video":
        if (!this.videoTree || forceReload) {
          this.videoTree = undefined;
          setTimeout(() => {
            if (this.updateTree) {
              this.updateTree.updateVideoTree();
            } else {
              // $rootScope.$emit("update-video-tree");
            }
          });
        }
        break;
      case "connector":
        if (!this.connectorTree || forceReload) {
          this.connectorTree = undefined;
          setTimeout(() => {
            if (this.updateTree) {
              this.updateTree.updateConnectorTree();
            } else {
              // $rootScope.$emit("update-connector-tree");
            }
          });
        }
        break;
    }

    if (!this.projectResourcesTree || forceReload) {
      this.projectResourcesTree = undefined;
      setTimeout(() => {
        if (this.updateTree && this.updateTree.updateProjectResourcesTree) {
          this.updateTree.updateProjectResourcesTree("",false);
        } else {
          // $rootScope.$emit("update-resources-tree");
        }
      });
    }
  }


  // Sets the activePath and activeResource using folder name.
  setActiveResource(activePath: any) {
    let fPath = activePath || this.folder,
      fName;
    if (fPath) {
      fName = fPath.split("/").pop();
      activeResource.selectedNodeProps = {
        name: fName,
        type: activePath ? 'file' : 'folder',
        path: fPath
      };
      this.activePath = fPath;

      this.activeResource = activeResource;
    }
  }


  onCancel(id: string) {
    this.dialogeServce.close(id);

  }


  uploadResource(dialogId: any, formName: any): any {
    let fileName: any,
      formData: any,
      uploadConfig,
      ActionService: any,
      prefabName,
      uploadPath = this.folder || this.selectedUpload.path,
      // All the restricted paths added here
      restrictedPaths = ['../lib/project-external-dependency-jars',
        '../project/lib/project-external-dependency-jars',
        '../project/generated-angular-app'
      ],
      $fileUpload = get(document.forms[formName], 'wmfile'),
      $fileUploadScope = $($fileUpload).closest('.wm-file-upload'),
      uploadFiles = get($fileUpload, 'files');

    // reset the file upload directive once the file is uploaded or onError.
    let resetFile = () => {
      $fileUploadScope
    };
    // set the uploadFiles, if files are dragged and dropped in dropzone.
    if (this.showDropView && this.dndFilesList.length) {
      uploadFiles = this.dndFilesList;
    }

    fileName = this.fileName || get(this.fileDetails, 'value') || uploadFiles[0]?.name;
    //restrict the file upload into the project-external-dependency-jars and generated-angular-app path
    let isRestrictedPath = restrictedPaths.find(function (path) {
      return uploadPath.startsWith(path);
    });
    if (isRestrictedPath) {
      // wmToaster.show('error', $rootScope.locale.MESSAGE_ERROR_TITLE, $rootScope.locale.MESSAGE_ERROR_UPLOAD_NOT_ALLOWED);
      this.resetShowDropView(formName);
      resetFile();
      return false;
    }
    /*TODO: to re-implement client-site resourceExists logic*/
    /*Preparing file path by trimming the '/' at starting and appending fileName at end separated by '/'*/
    /*filePath = $scope.folder.substr(1, $scope.folder.length - 1) + "/" + $scope.fileName;
    (uploadMode === 'resources') && isResourceExist($scope.resourcesTree[0].children, filePath);*/

    /* Condition to check whether HTML5 File API feature is supported. If not executing fallback.
     here, Checking all the possible window objects needed for file api*/

    if (isFileUploadSupported()) {
      /*Display error message if file is not selected and return.*/
      if (uploadFiles?.length === 0) {
        this.toggleMessage(true, this.locale.MESSAGE_ERROR_NO_FILE_SELECTED_DESC, 'error');
        this.resetShowDropView(formName);
        return false;
      }

      /*Hide the error message if file is selected.*/
      this.toggleMessage(false);


      /* Angular does not bind file values so using native object to send files */
      formData = new FormData();

      /*Append the multiple files that are uploaded*/
      if (uploadFiles?.length > 1) {
        forEach(uploadFiles, function (file, index) {
          formData.append('file' + index, file);
        });
      } else {
        /* Take the first selected file */
        formData.append('file', uploadFiles[0]);
      }

      uploadConfig = {
        action: 'upload',
        projectID: this.projectId,
        path: this.folder || this.selectedUpload.path,
        content: formData
      };

      /*Showing up the warning only for the first time*/
      if (this.resourceExists && !this.warningShown) {
        this.toggleMessage(true, replace(this.locale.MESSAGE_RESOURCE_EXISTS, [this.fileName]), 'warn');
        this.warningShown = true;
        this.resetShowDropView(formName);
        return false;
      }
      this.toggleMessage(true, this.locale.MESSAGE_IMPORT_RESOURCE, 'loading');

      if (this.uploadMode === 'prefabs') {
        ActionService = this.prefabService;
      } else if (this.uploadMode === 'themes') {
        ActionService = this.themeService;
      } else if (this.uploadMode === 'templatebundles') {
        ActionService = this.pageTemplatesService;
      } else {
        ActionService = this.fileService;
      }

      /*if uploading a prefab or theme, call corresponding service import method*/
      if (this.uploadMode === 'prefabs' || this.uploadMode === 'themes' || this.uploadMode === 'templatebundles') {
        /*Check if the selected file is zip file, then call call import prefab, else through an error message explaining the same*/
        if (isZipFile(uploadFiles[0].name)) {
          if (this.uploadMode === 'prefabs') {
            prefabName = uploadFiles[0].name;
            prefabName = prefabName.trim();
            /*Splicing out the extension out of the project name*/
            prefabName = prefabName.substr(0, prefabName?.length - 4);
            /*In case of prefab validating the project name to contain only letters and numbers*/
            if (prefabName && !this.projectService.validateName(prefabName)) {
              this.toggleMessage(true, this.locale.MESSAGE_ERROR_PREFAB_NAME_INVALID_DESC, 'error');
              this.resetShowDropView(formName);
              return false;
            }
            /*Hide the error message if file is selected.*/
            this.toggleMessage(false);
          }

          uploadConfig = {
            content: formData
          };

          if (this.uploadMode === 'prefabs') {
            uploadConfig = {
              content: formData,
              action:'upload'
            };
          }
          /*disabling the studio actions while the upload service is initiated*/
          // $rootScope.isStudioDisabled = true;

          ActionService.upload(uploadConfig).then((response: any) => {
            /*enabling the studio actions after success*/
            // $rootScope.isStudioDisabled = false;
            this.toggleMessage(false);
            this.closeDialog(dialogId);
            this.notificationService.show('success', this.locale.MESSAGE_SUCCESS_TITLE , this.locale.MESSAGE_SUCCESS_IMPORT );

            // wmToaster.show('success', $rootScope.locale.MESSAGE_SUCCESS_TITLE, getSuccessMsg());

            /*refresh the selected upload list*/
            // $rootScope.$emit(selectedUpload.emitEvent);

            // if (dialogParams.onImportSuccess) {
            //   triggerFn(dialogParams.onImportSuccess);
            // }

            if (this.uploadMode === 'templatebundles') {
              // TODO: Remove from runtimeEventManager and add this event to eventManager
              runtimeEventManager.emit('load-templatebundles');
            }

            if (this.uploadMode === 'prefabs') { //after uploading the prefab just reload the prefab list.
              this.prefabManager.loadPrefabList()
            }
            if (this.uploadMode === 'themes') {
              this.eventManager.getUploadedTheme(response);
            }
          }, (response: any) => {
            /*enabling the studio actions after failure*/
            // $rootScope.isStudioDisabled = false;
            this.toggleMessage(true, this.locale[this.selectedUpload.errorMsg] + ' : ' + response, 'error');
          });
        } else {
          this.toggleMessage(true, this.locale.MESSAGE_ERROR_ZIP_INVALID_FILE, 'error');
        }
      }
      //   else if (this.uploadMode === 'images') {
      //     if (isImageFile(uploadFiles[0].name)) {
      //
      //       /*disabling the studio actions while the upload service is initiated*/
      //       // $rootScope.isStudioDisabled = true;
      //
      //       /* Call service method to upload file */
      //       ActionService.upload(uploadConfig, function () {
      //         handleSuccessImport($scope.resourceView, getSuccessMsg(), dialogId, formName);
      //       });
      //     } else {
      //       $scope.toggleMessage(true, $rootScope.locale.MESSAGE_ERROR_IMAGE_INVALID_FILE, 'error');
      //     }
      //   // } else if (uploadMode === 'resources') {
      //   //   /*If either filename or the folder is missing, return*/
      //   //   if (!$scope.fileName || !$scope.folder) {
      //   //     $scope.toggleMessage(true, $rootScope.locale.MESSAGE_ERROR_NO_FILE_OR_FOLDER_SELECTED_DESC, 'error');
      //   //     resetShowDropView(formName);
      //   //     return false;
      //   //   }
      //   //   if (!Utils.isExeFile(uploadFiles[0].name)) {
      //   //
      //   //     /*disabling the studio actions while the upload service is initiated*/
      //   //     $rootScope.isStudioDisabled = true;
      //   //
      //   //     /* Call service method to upload file */
      //   //     ActionService.upload(uploadConfig, function () {
      //   //       handleSuccessImport($scope.resourceView, getSuccessMsg(), dialogId, formName);
      //   //     });
      //   //   } else {
      //   //     $scope.toggleMessage(true, $rootScope.locale.MESSAGE_ERROR_UNSUPPORTED_RESOURCE_FILE, 'error');
      //   //   }
      //   // }  else if (activeResource.name === 'connector') {
      //   //   for (var i=0; i< uploadFiles.length; i++) {
      //   //     if (!Utils.isZipFile(uploadFiles[i].name)) {
      //   //       $scope.toggleMessage(true, $rootScope.locale.MESSAGE_ERROR_ZIP_INVALID_FILE, 'error');
      //   //       return;
      //   //     }
      //   //   }
      //   //   ActionService.addConnector(uploadConfig, function(){
      //   //     handleSuccessImport($scope.resourceView, getSuccessMsg(), dialogId, formName)
      //   //   }, handleImportFailure)
      //   // } else {
      //
      //     /*disabling the studio actions while the upload service is initiated*/
      //     $rootScope.isStudioDisabled = true;
      //
      //     /* Call service method to upload file */
      //     ActionService.upload(uploadConfig, function () {
      //       handleSuccessImport($scope.resourceView, getSuccessMsg(), dialogId, formName);
      //     });
      //   }
      // } else {
      //   fileName = WM.element('[name=' + formName + ']').first().find('input[type="file"]').val();
      /*modifying resource upload path for image resources if executing fallback*/
      // if (uploadMode === 'images') {
      //   /*Check if the selected file is a valid image file, else through an error*/
      //   if (Utils.isImageFile(fileName)) {
      //     fileUploadFallbackConfig.url = Utils.getProjectResourcePath($rootScope.project.id) + ($scope.folder || selectedUpload.path);
      //   } else {
      //     $scope.toggleMessage(true, $rootScope.locale.MESSAGE_ERROR_IMAGE_INVALID_FILE, 'error');
      //     resetShowDropView(formName);
      //     return false;
      //   }
      // } else
      if (this.uploadMode === 'prefabs' || this.uploadMode === 'themes' || this.uploadMode === 'templatebundles') {
        /*Check if the selected file is a zip file, else through an error*/
        if (isZipFile(fileName)) {
          if (this.uploadMode === 'prefabs') {
            let index = fileName.indexOf("\\"),
              newFileName;
            if (index > -1) {
              newFileName = fileName.split('\\').pop().split('.')[0];
            } else {
              newFileName = fileName.split('.')[0];
            }
            /*In case of prefab validating the project name to contain only letters and numbers*/
            if (newFileName && !this.projectService.validateName(newFileName)) {
              this.toggleMessage(true, this.locale.MESSAGE_ERROR_PREFAB_NAME_INVALID_DESC, 'error');
              this.resetShowDropView(formName);
              return false;
            }
            /*Hide the error message if file is selected.*/
            this.toggleMessage(false);
          }
          this.fileUploadFallbackConfig.url = this.selectedUpload.path;
        } else {
          this.toggleMessage(true, this.locale.MESSAGE_ERROR_ZIP_INVALID_FILE, 'error');
          this.resetShowDropView(formName);
          return false;
        }
      } else if (this.uploadMode === 'resources') {
        /*If either filename or the folder is missing, return*/
        if (!this.fileName || !this.folder) {
          this.toggleMessage(true, this.locale.MESSAGE_ERROR_NO_FILE_OR_FOLDER_SELECTED_DESC, 'error');
          this.resetShowDropView(formName);
          return false;
        }
        /*Check if the selected file is not an exe file, else through an error*/
        if (!isExeFile(fileName)) {
          this.fileUploadFallbackConfig.url = getProjectResourcePath(this.projectId) + (this.folder || this.selectedUpload.path);
        } else {
          this.toggleMessage(true, this.locale.MESSAGE_ERROR_UNSUPPORTED_RESOURCE_FILE, 'error');
          this.resetShowDropView(formName);
          return false;
        }
      } else if (this.uploadMode === 'jars') {
        /*applying lib resource upload path as is from the selected upload type.*/
        this.fileUploadFallbackConfig.url = 'services/projects/' + this.projectId + '/resources/content/lib/' + (this.folder || this.selectedUpload.path);
      } else {
        /*applying resource upload path as is from the selected upload type.*/
        this.fileUploadFallbackConfig.url = this.selectedUpload.path;
      }

      /*adding packageType identifier to the upload config if packageType is specified for the upload type.*/
      if (this.selectedUpload.data) {
        this.fileUploadFallbackConfig.data = this.selectedUpload.data;
      }
      this.toggleMessage(true, this.locale.MESSAGE_IMPORT_RESOURCE, 'loading');

      this.fileUploadFallbackConfig.formName = formName;

      /*disabling the studio actions while the upload service is initiated*/
      // $rootScope.isStudioDisabled = true;

      /*calling file upload fallback registered with Utils service.*/
      // fileUploadFallback(this.fileUploadFallbackConfig,  ()=> {
      //   if (this.uploadMode === 'prefabs' || this.uploadMode === 'themes' || this.uploadMode === 'templatebundles') {
      //     /*enabling the studio actions after success*/
      //     // $rootScope.isStudioDisabled = false;
      //     this.toggleMessage(false);
      //     this.closeDialog(dialogId);
      //     // $rootScope.$emit(selectedUpload.emitEvent);
      //     // wmToaster.show('success', $rootScope.locale.MESSAGE_SUCCESS_TITLE, getSuccessMsg());
      //     // if (this.uploadMode === 'prefabs') { //after uploading the prefab just reload the prefab list.
      //     //   $rootScope.$emit('load-prefabs-list');
      //     // }
      //   } else {
      //     this.handleSuccessImport(this.resourceView, getSuccessMsg(), dialogId, formName);
      //   }
      // },  ()=> {
      //   /*enabling the studio actions after failure*/
      //   // $rootScope.isStudioDisabled = false;
      //
      //   /*invoking error callback if file upload failed.*/
      //   this.toggleMessage(true, this.locale[this.selectedUpload.errorMsg], 'error');
      // });
    }

    //on success reset the file upload element
    //otherwise fileupload onchange event will never be fired for the same file upload next time
    resetFile();

    // hide the dropview after the resource upload
    this.resetShowDropView(formName, true);
  };

  toggleMessage(show: any, msg?: any, type?: any) {
    switch (type) {
      case 'success':
        this.messageClass = 'alert-success';
        this.messageIconClass = 'wms wms-done';
        break;
      case 'error':
        this.messageClass = 'alert-danger';
        this.messageIconClass = 'wms wms-error-outline';
        break;
      case 'warn':  /*To support old projects with type as "warn"*/
      case 'warning':
        this.messageClass = 'alert-warning';
        this.messageIconClass = 'wms wms-bell';
        break;
      case 'info':
        this.messageClass = 'alert-info';
        this.messageIconClass = 'wms wms-info';
        break;
      case 'loading':
        this.messageClass = 'alert-info alert-loading';
        this.messageIconClass = 'fa fa-spinner fa-spin';
        break;
    }

    if (show) {
      this.uploadMessage = {'caption': msg || "", type: type};
      this.disableDialogActions = (type === 'loading');

      // show messages for 3sec and hide.
      if (type === 'success') {
        setTimeout( () => {
          this.uploadMessage = null;
        }, 3000);
      }
    } else {
      this.disableDialogActions = false;
      this.uploadMessage = null;
    }
  };

  resetShowDropView(formName: any, isLoading?: any) {
    if (!isLoading) {
      this.resetResourceUploadInput(formName);
    }
    // $rootScope.$evalAsync(function () {
    this.showDropView = false;
    // });
  }

  resetResourceUploadInput(formName: any) {
    if (formName) {
      if (document.forms[formName]) {
        // this.element(document.forms[formName]['file']).val('');
      }
    }
  }



  closeDialog(id?: any) {
    this.dialogeServce.close(id)

  }

}
